export const calculateImageBound = (dimension: number): number => dimension / 100 / 2;
